
import React, { Suspense } from 'react';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import { Toaster } from 'sonner';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/context';
import { ThemeProvider } from './components/ThemeProvider';
import { routes } from './routes';
import { ParticlesProvider } from './components/ui/particles';
import { ProgramDataProvider } from './context/ProgramDataContext';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopOnNavigate from './components/ScrollToTopOnNavigate';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import { LoadingSpinner } from './components/ui/loading-spinner';

const queryClient = new QueryClient();

const AppRoutes = () => {
  const routeElements = useRoutes(routes);
  return routeElements;
};

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTopOnNavigate />
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ParticlesProvider>
            <ThemeProvider>
              <ProgramDataProvider>
                <div className="relative">
                  <Suspense fallback={<div className="min-h-screen flex items-center justify-center bg-background"><LoadingSpinner size={40} /></div>}>
                    <AppRoutes />
                  </Suspense>
                  <Toaster />
                  <ScrollToTop />
                  <PWAInstallPrompt />
                </div>
              </ProgramDataProvider>
            </ThemeProvider>
          </ParticlesProvider>
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
};

export default App;
